<div class="container-fluid pt-2 compact-dashboard">

  <!-- Layout principal en dos columnas -->
  <div class="row h-100">
    <!-- Columna izquierda: Información del dispositivo, estado, contadores y parámetros -->
    <div class="col-lg-6 col-md-12 d-flex flex-column h-100">

      <!-- Información del Dispositivo -->
      <div class="row mb-2">
        <div class="col-12">
          <div class="card h-100">
            <div class="card-header py-2">
              <h6 class="card-title mb-0">
                Información del Dispositivo
              </h6>
            </div>
            <div class="card-body py-2">
              <div class="row">
                <!-- Columna izquierda: Información básica -->
                <div class="col-md-6">
                  <div class="d-flex flex-column gap-3">
                    <!-- Estado -->
                    <div class="text-center">
                      <div class="mb-1">
                        <i class="fas fa-wifi fs-5" [class.text-success]="data.alive"
                          [class.text-danger]="!data.alive"></i>
                      </div>
                      <small class="text-muted">Estado</small>
                    </div>
                  </div>
                </div>

                <!-- Columna derecha: Información técnica -->
                <div class="col-md-6">
                  <div class="d-flex flex-column justify-content-center h-100 gap-3">
                    <!-- Zona Horaria -->
                    <div>
                      <i class="fas fa-clock text-warning me-1"></i>
                      <strong class="small">Zona Horaria:</strong>
                      <small class="text-muted ms-1">{{data.timeZone}}</small>
                    </div>

                    <!-- Última Conexión -->
                    <div>
                      <i class="fas fa-history text-info me-1"></i>
                      <strong class="small">Última Conexión:</strong>
                      <small class="text-muted ms-1">{{formatLastSeen(data.lastSeen)}}</small>
                    </div>

                    <!-- Ubicación -->
                    <div>
                      <i class="fas fa-map-marker-alt text-danger me-1"></i>
                      <strong class="small">Ubicación:</strong>
                      <small class="text-muted ms-1">
                        {{data.location.city}}, {{data.location.region}}
                      </small>
                    </div>

                    <!-- Coordenadas -->
                    <div>
                      <i class="fas fa-crosshairs text-secondary me-1"></i>
                      <strong class="small">Coordenadas:</strong>
                      <small class="text-muted ms-1">{{data.location.lat}}, {{data.location.lon}}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Parámetros Instantáneos, Contadores y Estado en una fila -->
      <div class="row flex-fill">
        <!-- Parámetros Instantáneos - Ancho más reducido -->
        <div class="col-xl-5 col-lg-12 col-md-5 col-sm-12 d-flex">
          <div class="card flex-fill">
            <div class="card-header py-2">
              <h6 class="card-title mb-0">
                Parámetros Instantáneos
              </h6>
            </div>
            <div class="card-body py-2 d-flex flex-column justify-content-center align-items-center">
              <!-- Parámetros en layout vertical con iconos con estilo similar a contadores -->
              <div class="d-flex flex-column gap-3">
                <!-- Voltaje -->
                <div class="d-flex align-items-center">
                  <div class="data-item">
                    <div class="data-icon bg-warning bg-opacity-10 me-3">
                      <i class="fas fa-bolt text-warning"></i>
                    </div>
                    <div class="data-content">
                      <div class="data-value">{{data.electricalParams.voltage_V}} V</div>
                      <small class="data-label">Voltaje</small>
                    </div>
                  </div>
                </div>

                <!-- Corriente -->
                <div class="d-flex align-items-center">
                  <div class="data-item">
                    <div class="data-icon bg-danger bg-opacity-10 me-3">
                      <i class="fas fa-plug text-danger"></i>
                    </div>
                    <div class="data-content">
                      <div class="data-value">{{data.electricalParams.current_A}} A</div>
                      <small class="data-label">Corriente</small>
                    </div>
                  </div>
                </div>

                <!-- Potencia -->
                <div class="d-flex align-items-center">
                  <div class="data-item">
                    <div class="data-icon bg-success bg-opacity-10 me-3">
                      <i class="fas fa-battery-full text-success"></i>
                    </div>
                    <div class="data-content">
                      <div class="data-value">{{data.electricalParams.power_W}} W</div>
                      <small class="data-label">Potencia</small>
                    </div>
                  </div>
                </div>

                <!-- Frecuencia -->
                <div class="d-flex align-items-center">
                  <div class="data-item">
                    <div class="data-icon bg-primary bg-opacity-10 me-3">
                      <i class="fas fa-wave-square text-primary"></i>
                    </div>
                    <div class="data-content">
                      <div class="data-value">{{data.electricalParams.frequency_Hz}} Hz</div>
                      <small class="data-label">Frecuencia</small>
                    </div>
                  </div>
                </div>

                <!-- Temperatura -->
                <div class="d-flex align-items-center">
                  <div class="data-item">
                    <div class="data-icon bg-danger bg-opacity-10 me-3">
                      <i class="fas fa-temperature-high text-danger"></i>
                    </div>
                    <div class="data-content">
                      <div class="data-value">{{data.electricalParams.temperature_C}}°C</div>
                      <small class="data-label">Temperatura</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Columna derecha con Contadores y Estado apilados -->
        <div class="col-xl-7 col-lg-12 col-md-7 col-sm-12">
          <div class="d-flex flex-column h-100">
            <!-- Contadores -->
            <div class="card mb-2 flex-fill">
              <div class="card-header py-2">
                <h6 class="card-title mb-0 small">
                  Contadores
                </h6>
              </div>
              <div class="card-body py-2">
                <!-- Sección Horas -->
                <div class="mb-3">
                  <h6 class="text-muted small mb-2 text-center">
                    Horas de Funcionamiento
                  </h6>
                  <div class="d-flex justify-content-center align-items-center gap-4">
                    <!-- Horas Totales -->
                    <div class="text-center">
                      <div class="data-item">
                        <div class="data-icon bg-primary bg-opacity-10 mx-auto mb-2">
                          <i class="fas fa-clock text-primary"></i>
                        </div>
                        <div class="data-content text-center">
                          <div class="data-value">{{data.counters.totalRunHours_h.toLocaleString()}} h</div>
                          <small class="data-label">Totales</small>
                        </div>
                      </div>
                    </div>

                    <!-- Horas Parciales -->
                    <div class="text-center">
                      <div class="data-item">
                        <div class="data-icon bg-warning bg-opacity-10 mx-auto mb-2">
                          <i class="fas fa-clock text-warning"></i>
                        </div>
                        <div class="data-content text-center">
                          <div class="data-value">{{data.counters.partialRunHours_h}} h</div>
                          <small class="data-label">Parciales</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Separador -->
                <hr class="my-2">

                <!-- Sección Energía -->
                <div>
                  <h6 class="text-muted small mb-2 text-center">
                    Energía Consumida
                  </h6>
                  <div class="d-flex justify-content-center align-items-center gap-4">
                    <!-- Energía Total -->
                    <div class="text-center">
                      <div class="data-item">
                        <div class="data-icon bg-primary bg-opacity-10 mx-auto mb-2">
                          <i class="fas fa-bolt text-primary"></i>
                        </div>
                        <div class="data-content text-center">
                          <div class="data-value">{{data.counters.totalActiveEnergy_kWh}} kWh</div>
                          <small class="data-label">Total</small>
                        </div>
                      </div>
                    </div>

                    <!-- Energía Parcial -->
                    <div class="text-center">
                      <div class="data-item">
                        <div class="data-icon bg-warning bg-opacity-10 mx-auto mb-2">
                          <i class="fas fa-bolt text-warning"></i>
                        </div>
                        <div class="data-content text-center">
                          <div class="data-value">{{data.counters.partialActiveEnergy_kWh}} kWh</div>
                          <small class="data-label">Parcial</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Estado de Salidas -->
            <div class="card flex-fill">
              <div class="card-header py-2">
                <h6 class="card-title mb-0 small">
                 Estado
                </h6>
              </div>
              <div class="card-body py-2 d-flex align-items-center justify-content-center">
                <div class="text-center">
                  <div class="mb-2">
                    <i class="fas fa-lightbulb fs-4 text-warning"></i>
                  </div>
                  <div class="mb-1">
                    <h6 class="mb-0 text-primary fw-bold">Salida 1</h6>
                  </div>
                  <div
                    class="border border-success border-2 bg-success bg-opacity-10 text-success rounded-2 d-flex align-items-center justify-content-center fw-bold"
                    style="min-width: 80px; height: 32px; font-size: 0.9rem;">
                    ON
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Columna derecha: Gráfico de programación -->
    <div class="col-lg-6 col-md-12 d-flex flex-column h-100">
      <div class="card flex-fill">
        <div class="card-header py-2">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="card-title mb-0 small">
              Programación Semanal
            </h6>
            <button
              type="button"
                class="btn btn-sm border text-secondary bg-transparent rounded-pill" style="border-width:1px;"
              (click)="openSchedulerModal()"
              title="Editar programación">
              <i class="fas fa-edit me-1"></i>Editar
            </button>
          </div>
        </div>
        <div class="card-body py-2 flex-fill" [hidden]="hideSchedulerAnc">
          <!-- Componente de programación reutilizable -->
          <app-scheduler-anc
            [schedulerData]="getSchedulerData()"
            [outputCount]="1"
            [selectedOutput]="1"
            [sunTimesData]="sunTimesData"
            chartIdPrefix="chart">
          </app-scheduler-anc>
        </div>
      </div>
    </div>

  </div>
</div>
